import { Cambio, Estado } from './common';

export class ValorExpediente {
    expediente: string;
    caja: string;
    serieDocumental: string;
    destino: string;
    desde: string;
    hasta: string;
    sellador: string;
    calle: string;
    personaContacto: string;
    facturable: string;
    trasvase: string;
    sala: string;

    constructor() { }

    static toModel(json: string): ValorExpediente {
        const data = JSON.parse(json);
        const toReturn = new ValorExpediente();

        toReturn.expediente = data.EXPEDIENTE;
        toReturn.caja = data.CAJA;
        toReturn.serieDocumental = data.SERIE_DOCUMENTAL;
        toReturn.destino = data.DESTINO;
        toReturn.desde = data.DESDE;
        toReturn.hasta = data.HASTA;
        toReturn.sellador = data.SELLADOR;
        toReturn.calle = data.CALLE;
        toReturn.personaContacto = data.PERSONA_DE_CONTACTO;
        toReturn.facturable = data.FACTURABLE;
        toReturn.trasvase = data.TRASVASE;
        toReturn.sala = data.SALA;

        return toReturn;
    }
}

export class Bloqueo {
    idUsuarioBloqueo: number;
    infoBloqueo: string;
    fechaInicioBloqueo: Date;
    fechaFinBloqueo: Date;
    idUsuarioDesbloqueo: number;

    constructor() { }

    static toModel(json: string) {
        const data = JSON.parse(json);
        const toReturn = new Bloqueo();

        toReturn.idUsuarioBloqueo = data.ID_USUARIO_BLOQUEO;
        toReturn.infoBloqueo = data.INFO_BLOQUEO;
        toReturn.fechaInicioBloqueo = data.FECHA_INICIO_BLOQUEO ? new Date(data.FECHA_INICIO_BLOQUEO) : undefined;
        toReturn.fechaFinBloqueo = data.FECHA_FIN_BLOQUEO ? new Date(data.FECHA_FIN_BLOQUEO) : undefined;
        toReturn.idUsuarioDesbloqueo = data.ID_USUARIO_DESBLOQUEO;

        return toReturn;
    }
}

export class ExpedienteDetail {
    idContenedor: number;
    idAz: string;
    idSerie: number;
    idUsuarioCreacion: number;
    idSecLevel: number;
    idCliente: number;
    fechaCreacion: Date;
    fechaExpurgo: Date;
    descripcion: string;
    estado: Estado;
    bloqueos: Bloqueo[];
    imagenAsociada: string;
    // parciales?: any;
    // historialSolicitudes?: any[];
    historialCambios: Cambio[];
    // gruposAcceso?: any;
    valores: ValorExpediente[];
    hasFullTextCoincidence: boolean;
    id: string;

    constructor() { }

    static toModel(json: string): ExpedienteDetail {
        const data = JSON.parse(json);
        const toReturn = new ExpedienteDetail();

        toReturn.idContenedor = data.ID_CONTENEDOR;
        toReturn.idAz = data.ID_AZ;
        toReturn.idSerie = data.ID_SERIE;
        toReturn.idUsuarioCreacion = data.ID_USUARIO_CREACION;
        toReturn.idSecLevel = data.ID_SEC_LEVEL;
        toReturn.idCliente = data.ID_CLIENTE;
        if (data.FECHA_CREACION) {
            toReturn.fechaCreacion = data.FECHA_CREACION;
        }
        if (data.FECHA_EXPURGO) {
            toReturn.fechaExpurgo = new Date(data.FECHA_EXPURGO);
        }
        toReturn.descripcion = data.DESCRIPCION;
        if (data.ESTADO) {
            toReturn.estado = Estado.toModel(JSON.stringify(data.ESTADO));
        }
        if (data.BLOQUEOS) {
            toReturn.bloqueos = data.BLOQUEOS.map((bloqueo: any) => Bloqueo.toModel(JSON.stringify(bloqueo)));
        }
        toReturn.imagenAsociada = data.IMAGEN_ASOCIADA;
        // toReturn.PARCIALES = data.PARCIALES;
        // toReturn.HISTORIAL_SOLICITUDES = data.HISTORIAL_SOLICITUDES;
        if (data.HISTORIAL_CAMBIOS) {
            toReturn.historialCambios = data.HISTORIAL_CAMBIOS.map((cambio: any) => Cambio.toModel(JSON.stringify(cambio)));
        }
        // toReturn.GRUPOS_ACCESO = data.GRUPOS_ACCESO;
        if (data.Valores) {
            toReturn.valores = [].concat(data.Valores).map((valor: any) => ValorExpediente.toModel(JSON.stringify(valor)));
        }
        toReturn.hasFullTextCoincidence = data.HasFullTextCoincidence;
        toReturn.id = data.Id;

        return toReturn;
    }

}
